var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("会员权益")]),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "p",
              {
                staticStyle: {
                  width: "50px",
                  "font-size": "16px",
                  color: "#333",
                  "text-align": "right",
                  "margin-right": "26px",
                },
              },
              [_vm._v(" 赠品 ")]
            ),
            _c("el-switch", {
              model: {
                value: _vm.gift,
                callback: function ($$v) {
                  _vm.gift = $$v
                },
                expression: "gift",
              },
            }),
          ],
          1
        ),
        _vm.gift
          ? _c("div", { staticClass: "infobox" }, [
              _c("div", { staticClass: "infobox-content" }, [
                _c(
                  "div",
                  { staticClass: "info-item" },
                  [
                    _vm._m(0),
                    _c("el-input", {
                      staticClass: "inputarea",
                      attrs: {
                        type: "textarea",
                        maxlength: "100",
                        resize: "none",
                        placeholder: "请输入赠品说明",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.giveawayText,
                        callback: function ($$v) {
                          _vm.giveawayText = $$v
                        },
                        expression: "giveawayText",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-item",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _vm._m(1),
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.selectGoods },
                          },
                          [_vm._v("选择商品")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "45%" } },
                              _vm._l(_vm.allList, function (item, index) {
                                return index % 2 == 0
                                  ? _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "goods-item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "number-dot" },
                                          [_vm._v(_vm._s(index + 1))]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "goods-title" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _c("input-number", {
                                          attrs: {
                                            num: item.num,
                                            max: item.stock,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getGoodsCount(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "del",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delGoods(index)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                            _c(
                              "div",
                              { staticStyle: { width: "45%" } },
                              _vm._l(_vm.allList, function (item, index) {
                                return index % 2 != 0
                                  ? _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "goods-item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "number-dot" },
                                          [_vm._v(_vm._s(index + 1))]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "goods-title" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _c("input-number", {
                                          attrs: {
                                            num: item.num,
                                            max: item.stock,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getGoodsCount(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "del",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delGoods(index)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticStyle: { display: "flex", "margin-top": "24px" } },
          [
            _c(
              "p",
              {
                staticStyle: {
                  width: "50px",
                  "font-size": "16px",
                  color: "#333",
                  "text-align": "right",
                  "margin-right": "26px",
                },
              },
              [_vm._v(" 优惠券 ")]
            ),
            _c("el-switch", {
              model: {
                value: _vm.coupon,
                callback: function ($$v) {
                  _vm.coupon = $$v
                },
                expression: "coupon",
              },
            }),
          ],
          1
        ),
        _vm.coupon
          ? _c("div", { staticClass: "infobox" }, [
              _c("div", { staticClass: "infobox-content" }, [
                _c(
                  "div",
                  { staticClass: "info-item" },
                  [
                    _vm._m(2),
                    _c("el-input", {
                      staticClass: "inputarea",
                      attrs: {
                        type: "textarea",
                        maxlength: "100",
                        resize: "none",
                        placeholder: "请输入优惠券说明",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.couponText,
                        callback: function ($$v) {
                          _vm.couponText = $$v
                        },
                        expression: "couponText",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-item",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _vm._m(3),
                    _c(
                      "div",
                      { staticStyle: { width: "100%" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.selectCoupon },
                          },
                          [_vm._v("选择优惠券")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "45%" } },
                              _vm._l(_vm.allCouponList, function (item, index) {
                                return index % 2 == 0
                                  ? _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "goods-item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "number-dot" },
                                          [_vm._v(_vm._s(index + 1))]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "goods-title" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _c("input-number", {
                                          attrs: { num: item.num },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getCouponCount(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "del",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delCoupon(index)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                            _c(
                              "div",
                              { staticStyle: { width: "45%" } },
                              _vm._l(_vm.allCouponList, function (item, index) {
                                return index % 2 != 0
                                  ? _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "goods-item",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "number-dot" },
                                          [_vm._v(_vm._s(index + 1))]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "goods-title" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _c("input-number", {
                                          attrs: { num: item.num },
                                          on: {
                                            input: function ($event) {
                                              return _vm.getCouponCount(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "del",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delCoupon(index)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticStyle: { height: "20px" } }),
      ]),
      _vm.gift || _vm.coupon
        ? _c(
            "div",
            { staticClass: "content bottom-but" },
            [
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.toBack } },
                [_vm._v("返回")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitFn } },
                [_vm._v("确认")]
              ),
              _c("div", { staticStyle: { height: "20px" } }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "815",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "600px", "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    staticStyle: { width: "224px", "margin-right": "20px" },
                    attrs: {
                      placeholder: "请输入商品名称/商品编号",
                      size: "mini",
                    },
                    model: {
                      value: _vm.goodsName,
                      callback: function ($$v) {
                        _vm.goodsName = $$v
                      },
                      expression: "goodsName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: { click: _vm.searchD },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.goodsList,
                    "show-header": false,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("img", {
                                staticStyle: {
                                  width: "72px",
                                  height: "56px",
                                  "margin-right": "12px",
                                },
                                attrs: { src: scope.row.image, alt: "" },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    height: "56px",
                                    display: "flex",
                                    "flex-direction": "column",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#333333" } },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  ),
                                  _c(
                                    "p",
                                    { staticStyle: { color: "#999999" } },
                                    [
                                      _vm._v(
                                        " 商品编号：" +
                                          _vm._s(scope.row.goodsNo) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    height: "42px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.pageNo,
                      "page-sizes": [5, 10, 20, 30],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmFn } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择优惠券",
            "append-to-body": true,
            visible: _vm.couponDialog,
            "close-on-click-modal": false,
            width: "815",
          },
          on: {
            "update:visible": function ($event) {
              _vm.couponDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "600px", "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c("el-input", {
                    staticStyle: { width: "224px", "margin-right": "20px" },
                    attrs: { placeholder: "请输入优惠券名称", size: "mini" },
                    model: {
                      value: _vm.couponName,
                      callback: function ($$v) {
                        _vm.couponName = $$v
                      },
                      expression: "couponName",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: { click: _vm.searchC },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "couponTable",
                  attrs: {
                    data: _vm.couponList,
                    "show-header": false,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleCouponSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "60" },
                  }),
                  _c("el-table-column", { attrs: { prop: "name", label: "" } }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    height: "42px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.couponPageNo,
                      "page-sizes": [5, 10, 20, 30],
                      "page-size": _vm.couponPageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.couponTotalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeChangeCou,
                      "current-change": _vm.handleCurrentChangeCou,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.couponDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCouponFn },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticClass: "item-title", staticStyle: { "margin-right": "6px" } },
      [
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
        _vm._v("赠品说明 "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "item-title" }, [
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v("选择赠品"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "p",
      { staticClass: "item-title", staticStyle: { "margin-right": "6px" } },
      [
        _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
        _vm._v("优惠券说明 "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "item-title" }, [
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
      _vm._v("选择优惠券 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }